import store from "@/store";
import { ROUTES } from "@/router/router.config";

async function beforeEachGuard(to, from, next) {
  const isNextPageRequireAuth = to.meta.requireAuth;
  const isAuthenticated = await store.dispatch("users/isAuthenticated");

  let nextNavigation = {};
  if (isNextPageRequireAuth && !isAuthenticated) {
    nextNavigation = { name: ROUTES.login.name };
  } else if (isAuthenticated && ROUTES.login.name === to.name) {
    nextNavigation = from.name
      ? { name: from.name }
      : { name: ROUTES.home.name };
  }

  next(nextNavigation);
}

export { beforeEachGuard };
